import { Icon } from '@iconify/react/dist/iconify.js';
import React, { useState, useEffect, useRef } from 'react';
import Select from 'react-select';
import Swal from 'sweetalert2';
import Quill from 'quill';
import 'quill/dist/quill.snow.css';
import { API_URL } from '..';

// Function to get current and +14 days date
function getDates() {
  const today = new Date();
  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };
  const currentDate = formatDate(today);
  const dateAfter14Days = new Date(today);
  dateAfter14Days.setDate(today.getDate() + 14);
  const fourteenthDate = formatDate(dateAfter14Days);
  return { currentDate, fourteenthDate };
}

// Invoice template
const professionalTemplate = `
<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Invoice</title>
    <style>
      /* Ensure consistent styling for Quill content */
      .ql-align-center { text-align: center; }
      .ql-align-right { text-align: right; }
      ul, ol { margin-left: 20px; padding-left: 0; }
      li { margin-bottom: 5px; }
    </style>
</head>
<body style="font-family: Arial, sans-serif; margin: 0; padding: 40px; font-size: 12px; color: #000;">
    <!-- Page 1 -->
    <div style="width: 100%; height: auto; margin: 0 auto; padding-top: 20px; box-sizing: border-box;">
        <!-- Header -->
        <table style="width: 100%; border-collapse: collapse;">
            <tr>
                <td style="width: 50%; vertical-align: top;padding-left:15px;">
                    <div style="font-weight: bold; font-size: 14px;">
                    <img src="{{business_logo}}" style="width:140px;padding-left:10px"/>
                    </div>
                    <div style="font-weight: bold; font-size: 14px;padding-left:30px">{{business_header}}</div>
                    <div style="width:150px;text-align:center;font-size:13px">{{business_address}}</div>
                    <div style="font-size:13px;padding-left:10px">{{business_email}}</div>
                    <div style="font-size:13px;padding-left:10px">VAT NO: {{vat_reg_no}}</div>
                </td>
                <td style="width: 50%; text-align: right; vertical-align: top;padding-right:20px">
                    <div style="font-size:13px;">Issue Date: {{issue_date}}</div>
                </td>
            </tr>
        </table>
        <!-- Bill To -->
        <div style="text-align:center;padding-top:10px">
        <p style="font-weight: 600; font-size: 18px;">{{type}}</p>
        </div>
        <div style="border-top:3px solid #d17f15;margin-top:10px"/>
        <table style="width: 100%; border-collapse: collapse; margin-top: 20px;">
            <tr>
                <td style="width: 70%; vertical-align: top;padding-left:10px">
                    <div style="font-weight: bold;">For:</div>
                    <div>{{customer_name}}</div>
                    <div>{{customer_phone}}</div>
                    <div>{{customer_address}}</div>
                </td>
                <td style="width: 30%;text-align:left">
                <div>Invoice No: {{invoice_number}}</div>
                {{order_number}}
                {{job_site_address}}
                </td>
            </tr>
        </table>
        <!-- Description Table -->
        <table style="width: 100%; border-collapse: collapse; margin-top: 20px;">
            <tr style="background-color: #d17f15;">
                <th style="text-align: left; padding: 5px; border-top: 2px solid #d17f15;border-bottom: 2px solid #d17f15;color:white">Description</th>
                <th style="text-align: center; padding: 5px; border-top: 2px solid #d17f15;border-bottom: 2px solid #d17f15;color:white">Quantity</th>
                <th style="text-align: center; padding: 5px; border-top: 2px solid #d17f15;border-bottom: 2px solid #d17f15;color:white">Unit Price</th>
                <th style="text-align: right; padding: 5px; border-top: 2px solid #d17f15;border-bottom: 2px solid #d17f15;color:white">Cost</th>
            </tr>
            {{service_items}}
        </table>
        <!-- Payment Instructions -->
        <table style="width: 100%; border-collapse: collapse; margin-top: 20px;padding:10px">
            <tr>
                <td style="width: 50%; vertical-align: top; background: #f2f2f2; border:3px solid #d17f15; text-align:center; padding: 10px;">
                    <div style="font-weight: bold;">Payment Instructions</div>
                    <div>{{accountTitle}}</div>
                    <div>Sort code: {{sortCode}}</div>
                    <div>Account no: {{accountNumber}}</div>
                </td>
                <td style="width: 50%; vertical-align: top; text-align: right;">
                    <div style="padding:5px;background:#f3f3f3">Total Net Amount: £{{subtotal}}</div>
                    {{discount}}
                    {{tax}}
                    <div style="border:1px solid #d17f15;"></div>
                    <div style="font-weight: bold;padding:5px">Invoice Total : £{{total}}</div>
                    <div style="border:1px solid #d17f15;"></div>
                </td>
            </tr>
        </table>
        <!-- Terms -->
        <div style="margin-top: 20px;padding:10px">
            <div style="font-weight: bold;font-size:14px;">Payment Terms</div>
            <div style="font-size: 13px;">Payment due 14 days from invoice date</div>
        </div>
    </div>
    <!-- Page 2 -->
    <div style="width: 100%; height: 842px; margin: 0px auto; padding: 10px; box-sizing: border-box; page-break-before: always;">
        <!-- Terms and Conditions -->
        <div style="margin-top: 20px;">
            <div style="font-weight: bold;">Terms and Conditions:</div>
            <div style="margin-top: 10px;font-size:13px">
                <div><strong>Payment Due Date:</strong> Full payment is due within 30 days from the invoice date.</div>
                <div><strong>Late Payments:</strong> A late fee of 5% of the total invoice amount will be applied to any payment not received by the due date. Interest on overdue balances will accrue at 5% per week until payment is received in full.</div>
                <div><strong>Methods of Payment:</strong> Payment can be made via bank transfer. Please ensure the invoice number is included in all payments for proper processing.</div>
                <div><strong>Disputes:</strong> Any disputes regarding the invoice must be reported in writing within 7 days of the invoice date. Disputing any portion of the invoice does not suspend the obligation to pay the undisputed amount by the due date.</div>
                <div><strong>Suspension of Service:</strong> Non-payment may result in suspension of service or further legal action, at the discretion of R-Wire Limited.</div>
            </div>
            <div style="margin-top: 20px;">
                <div style="font-weight: bold;">Disclaimer:</div>
                <div style="font-size:13px">If payment of invoices is not received, we reserve the right to recover any cost, commissions or fees incurred for the collection of payments including those which may be incurred by using a debt collection agency. There will be a 5% late payment fee applied every 7 days after the due date of the invoice.</div>
            </div>
        </div>
        <!-- Signature -->
        <div style="margin-top: 40px;">
            <div><strong>{{business_footer}}</strong></div>
            <div>{{issue_date_footer}}</div>
            <div>{{business_phone}}</div>
        </div>
        <div style="display: flex; column-gap: 10px; justify-content: center; border-top: 1px solid #c0c0c0; padding-top: 22px; margin-top: 20px;">
            <div style="width:15%">
                <img style="width: 127px;" src="https://api.test.frontforcecrm.com/logo/mainlogo.png">
            </div>
            <div style="width:10%">
                <img style="width: 110px;" src="https://api.test.frontforcecrm.com/logo/child.webp">
            </div>
            <div style="width:15%">
                <img style="width: 180px;" src="https://api.test.frontforcecrm.com/logo/update.jpeg">
            </div>
            <div style="width: 20%;">
                <img style="width: 230px;" src="https://api.test.frontforcecrm.com/logo/trustmark.jpeg">
            </div>
            <div style="width:20%">
                <img style="width: 195px;" src="https://api.test.frontforcecrm.com/logo/last.jpeg">
            </div>
        </div>
    </div>
</body>
</html>
`;

/**
 * JobInvoiceLayer component for creating an invoice for a specific job with company selection.
 * @param {Object} props - Component props.
 * @param {string} props.jobId - The ID of the job to create an invoice for.
 * @returns {JSX.Element} The rendered invoice creation component.
 */
const JobInvoiceLayer = ({ jobId }) => {
  const { currentDate, fourteenthDate } = getDates();
  const [mainData,setMainData] = useState(null)
  const [currentStep, setCurrentStep] = useState(1);
  const [companyData, setCompanyData] = useState({
    id: '',
    name: '',
    address: '',
    email: '',
    phone: '',
    vatRegNo: '',
    logo: '',
    accountNumber: '',
    accountTitle: '',
    sortCode: '',
  });
  const [invoiceNumber, setInvoiceNumber] = useState('')
  const [companies, setCompanies] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [invoiceData, setInvoiceData] = useState({
    orderNumber: 'RW-'+jobId,
    invoiceNumber: '',
    issuedDate: currentDate,
    dueDate: fourteenthDate,
    customerName: '',
    customerAddress: '',
    customerPhone: '',
    job_site_address:'',
    email: '',
    postcode: '',
    latitude: '',
    longitude: '',
  });
  const [invoiceItems, setInvoiceItems] = useState([]);
  const [newItem, setNewItem] = useState({
    itemType: 'stock',
    itemName: null,
    qty: '',
    unitPrice: '',
    description: '',
  });
  const [discount, setDiscount] = useState(0);
  const [taxAmount, setTaxAmount] = useState(0);
  const [errors, setErrors] = useState({});
  const [alert, setAlert] = useState({ show: false, type: '', message: '' });
  const [stockList, setStockList] = useState([]);
  const [optionsForServices, setOptionsForServices] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const quillRef = useRef(null);
  const quillInstance = useRef(null);

  // Fetch job details, company data, stock, services, and invoice number on mount
  useEffect(() => {
    const fetchJobDetails = async () => {
      try {
        const response = await fetch(`${API_URL}/api/job/fetch-single/${jobId}`, {
          method: 'GET',
          headers: { Accept: '*/*', 'Content-Type': 'application/json' },
        });
        if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
        const user = await response.json();
        const data = user.job;
        setMainData(data)
        setInvoiceData({
          ...invoiceData,
          customerName: data.client_name || '',
          customerAddress: data.customer?.address || '',
          customerPhone: data.phone || '',
          email: data.email || '',
          postcode: data.postcode || '',
          latitude: data.map_location?.split(',')[0] || '',
          longitude: data.map_location?.split(',')[1] || '',
        });
      } catch (error) {
        setAlert({ show: true, type: 'danger', message: 'Failed to fetch job details: ' + error.message });
      }
    };

    const fetchCompanyData = async () => {
      const user = JSON.parse(localStorage.getItem('user'));
      if (!user) {
        window.location.href = '/sign-in';
        return;
      }
      try {
        const response = await fetch(`${API_URL}/api/company`, {
          method: 'GET',
          headers: { Accept: '*/*', 'Content-Type': 'application/json' },
        });
        if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
        const data = await response.json();
        if (data.companies && data.companies.length > 0) {
          const formattedCompanies = data.companies.map((company) => ({
            label: company.name,
            value: company.id,
            data: {
              id: company.id,
              name: company.name || '',
              address: company.address || '',
              email: company.email || '',
              phone: company.phone || '',
              vatRegNo: company.vat || company.vatNo || '',
              logo: company.logo ? `${API_URL}${company.logo}` : '',
              accountNumber: company.accountNumber || '',
              sortCode: company.sortCode || '',
              accountTitle: company.accountTitle || '',
            },
          }));
          setCompanies(formattedCompanies);
          // Set first company as default
          setSelectedCompany(formattedCompanies[0] || null);
          setCompanyData(formattedCompanies[0]?.data || {
            id: '',
            name: '',
            address: '',
            email: '',
            phone: '',
            vatRegNo: '',
            logo: '',
            accountNumber: '',
            accountTitle: '',
            sortCode: '',
          });
        } else {
          setAlert({ show: true, type: 'danger', message: 'No companies found' });
        }
      } catch (error) {
        setAlert({ show: true, type: 'danger', message: 'Failed to fetch company data: ' + error.message });
      }
    };

    const fetchStock = async () => {
      const user = JSON.parse(localStorage.getItem('user'));
      if (!user) {
        window.location.href = '/sign-in';
        return;
      }
      try {
        const response = await fetch(`${API_URL}/api/invoice/stock/fetch`, {
          method: 'GET',
          headers: { Accept: '*/*', 'Content-Type': 'application/json' },
        });
        if (!response.ok) throw new Error('Failed to fetch stock');
        const data = await response.json();
        const formatted = data.stock.map((e) => ({ label: e.title, value: e.id }));
        setStockList(formatted);
      } catch (error) {
        setAlert({ show: true, type: 'danger', message: 'Failed to fetch stock items' });
      }
    };

    const fetchServices = async () => {
      const user = JSON.parse(localStorage.getItem('user'));
      if (!user) {
        window.location.href = '/sign-in';
        return;
      }
      try {
        const response = await fetch(`${API_URL}/api/service`, {
          method: 'GET',
          headers: { Accept: '*/*', 'Content-Type': 'application/json' },
        });
        const data = await response.json();
        const formatted = data.map((e) => ({ label: e.title, value: e.id }));
        setOptionsForServices(formatted);
      } catch (error) {
        setAlert({ show: true, type: 'danger', message: 'Failed to fetch services items' });
      }
    };

    const fetchInvoiceNumber = async () => {
      try {
        const response = await fetch(`${API_URL}/api/invoice/invoice-number`, {
          method: 'GET',
          headers: { Accept: '*/*', 'Content-Type': 'application/json' },
        });
        const data = await response.json();
        setInvoiceNumber(data.counter)
        setInvoiceData((prev) => ({ ...prev, invoiceNumber: data.counter }));
      } catch (error) {
        setAlert({ show: true, type: 'danger', message: 'Failed to fetch invoice number' });
      }
    };

    fetchJobDetails();
    fetchCompanyData();
    fetchStock();
    fetchServices();
    fetchInvoiceNumber();
  }, [jobId]);

  // Initialize Quill editor
  useEffect(() => {
    if (currentStep === 2 && quillRef.current && !quillInstance.current) {
      quillInstance.current = new Quill(quillRef.current, {
        theme: 'snow',
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline'],
            [{ list: 'ordered' }, { list: 'bullet' }],
            [{ align: '' }, { align: 'center' }, { align: 'right' }],
          ],
        },
        placeholder: 'Enter item description',
      });

      quillInstance.current.root.setAttribute('dir', 'ltr');
      quillInstance.current.root.setAttribute('lang', 'en');

      quillInstance.current.on('text-change', () => {
        const content = quillInstance.current.root.innerHTML;
        setNewItem((prev) => ({ ...prev, description: content }));
        quillInstance.current.focus();
      });

      quillInstance.current.focus();
    }

    return () => {
      if (quillInstance.current) {
        quillInstance.current.off('text-change');
        quillInstance.current = null;
      }
    };
  }, [currentStep]);

  // Update Quill content
  useEffect(() => {
    if (quillInstance.current && newItem.description) {
      if (quillInstance.current.root.innerHTML !== newItem.description) {
        quillInstance.current.root.innerHTML = newItem.description;
        quillInstance.current.focus();
      }
    }
  }, [newItem.description]);

  const onChangeService = async (value) => {
    const user = JSON.parse(localStorage.getItem('user'));
    if (!user) {
      window.location.href = '/sign-in';
      return;
    }
    try {
      const response = await fetch(`${API_URL}/api/service/${value.value}`, {
        method: 'GET',
        headers: { Accept: '*/*', 'Content-Type': 'application/json' },
      });
      if (!response.ok) throw new Error('Failed to fetch service details');
      const data = await response.json();
      setNewItem({
        ...newItem,
        itemName: value,
        qty: '1',
        description: data.description,
        unitPrice: data.price,
      });
    } catch (error) {
      setAlert({ show: true, type: 'danger', message: 'Failed to fetch service details' });
    }
  };

  const onChangeStock = async (value) => {
    const user = JSON.parse(localStorage.getItem('user'));
    if (!user) {
      window.location.href = '/sign-in';
      return;
    }
    try {
      const response = await fetch(`${API_URL}/api/invoice/stock/fetch-single/${value.value}`, {
        method: 'GET',
        headers: { Accept: '*/*', 'Content-Type': 'application/json' },
      });
      if (!response.ok) throw new Error('Failed to fetch stock details');
      const data = await response.json();
      setNewItem({
        ...newItem,
        itemName: value,
        unitPrice: data.stock.sellPrice,
        description: data.stock.description,
      });
    } catch (error) {
      setAlert({ show: true, type: 'danger', message: 'Failed to fetch stock details' });
    }
  };

  const handleCompanyChange = (selectedOption) => {
    setSelectedCompany(selectedOption);
    setCompanyData(selectedOption ? selectedOption.data : {
      id: '',
      name: '',
      address: '',
      email: '',
      phone: '',
      vatRegNo: '',
      logo: '',
      accountNumber: '',
      accountTitle: '',
      sortCode: '',
    });
    setErrors({ ...errors, company: '' });
  };

  const handleInvoiceChange = (field, value) => {
    setInvoiceData({ ...invoiceData, [field]: value });
    setErrors({ ...errors, [field]: '' });
  };

  const handleItemChange = (field, value) => {
    setNewItem({ ...newItem, [field]: value });
    setErrors({ ...errors, [field]: '' });
  };

  const addItem = () => {
    const errors = {};
    if (!newItem.itemName) errors.itemName = 'Item is required';
    if (!newItem.unitPrice) errors.unitPrice = 'Unit price is required';
    if (newItem.itemType === 'stock' && !newItem.qty) errors.qty = 'Quantity is required';
    if (!newItem.description.trim() || newItem.description === '<p><br></p>') errors.description = 'Description is required';

    if (Object.keys(errors).length > 0) {
      setErrors(errors);
      return;
    }

    const qty = newItem.itemType === 'service' ? 1 : parseFloat(newItem.qty);
    setInvoiceItems([
      ...invoiceItems,
      {
        id: invoiceItems.length + 1,
        itemName: newItem.itemName,
        qty,
        unitPrice: parseFloat(newItem.unitPrice),
        price: (qty * parseFloat(newItem.unitPrice)).toFixed(2),
        description: newItem.description.trim(),
      },
    ]);
    setNewItem({ itemType: 'stock', itemName: null, qty: '', unitPrice: '', description: '' });
    if (quillInstance.current) {
      quillInstance.current.root.innerHTML = '';
      quillInstance.current.focus();
    }
    setErrors({});
  };

  const removeItem = (id) => {
    setInvoiceItems(invoiceItems.filter((item) => item.id !== id));
  };

  const calculateSubtotal = () => invoiceItems.reduce((acc, item) => acc + parseFloat(item.price), 0);

  const calculateDiscount = () => (calculateSubtotal() * discount) / 100;

  const calculateTax = () => ((calculateSubtotal() - calculateDiscount()) * taxAmount) / 100;

  const calculateTotal = () => {
    const subtotal = calculateSubtotal();
    const discountAmount = calculateDiscount();
    const tax = calculateTax();
    return subtotal - discountAmount + tax;
  };

  const validateStep = () => {
    const newErrors = {};
    if (currentStep === 1) {
      if (!selectedCompany) newErrors.company = 'Company is required';
      if (!invoiceNumber) newErrors.invoiceNumber = 'Invoice number is required';
      if (!invoiceData.issuedDate) newErrors.issuedDate = 'Issued date is required';
      if (!invoiceData.dueDate) newErrors.dueDate = 'Due date is required';
    } else if (currentStep === 2) {
      if (invoiceItems.length === 0) newErrors.items = 'At least one item is required';
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleNext = () => {
    if (validateStep()) {
      setCurrentStep(currentStep + 1);
      setErrors({});
    }
  };

  const handleBack = () => {
    setCurrentStep(currentStep - 1);
    setErrors({});
  };

  const handleStepClick = (step) => {
    if (step <= currentStep) {
      setCurrentStep(step);
      setErrors({});
    }
  };

  const renderTemplate = () => {
    function checkOddEven(index) {
      return index % 2 === 0 ? 'Even' : 'Odd';
    }

    function convertDateFormat(dateString) {
      const [year, month, day] = dateString.split('-');
      const date = `${day}-${month}-${year}`;
      return date;
    }

    const serviceItems = invoiceItems
      .map((item, index) => {
        const descriptionHtml = item.description || 'N/A';
        if (checkOddEven(index) === 'Even') {
          return `
            <tr>
              <td style="padding: 5px; vertical-align: top; border: 1px dotted #c0c0c0; border-left: 1px dotted #c0c0c0; font-size:14px">
                ${item.itemName?.label || item.itemName?.value || 'N/A'}<br>
                <div>${descriptionHtml}</div>
              </td>
              <td style="text-align: center; padding: 5px; border: 1px dotted #c0c0c0; font-size:14px">${item.qty}</td>
              <td style="text-align: center; padding: 5px; border: 1px dotted #c0c0c0; font-size:14px">£${item.unitPrice.toFixed(2)}</td>
              <td style="text-align: right; padding: 5px; border: 1px dotted #c0c0c0; font-size:14px">£${item.price}</td>
            </tr>
          `;
        } else {
          return `
            <tr style="background:#f3f3f3">
              <td style="padding: 5px; vertical-align: top; border: 1px dotted #c0c0c0; border-left: 1px dotted #c0c0c0; font-size:14px">
                ${item.itemName?.label || item.itemName?.value || 'N/A'}<br>
                <div>${descriptionHtml}</div>
              </td>
              <td style="text-align: center; padding: 5px; border: 1px dotted #c0c0c0; font-size:14px">${item.qty}</td>
              <td style="text-align: center; padding: 5px; border: 1px dotted #c0c0c0; font-size:14px">£${item.unitPrice.toFixed(2)}</td>
              <td style="text-align: right; padding: 5px; border: 1px dotted #c0c0c0; font-size:14px">£${item.price}</td>
            </tr>
          `;
        }
      })
      .join('');

    return professionalTemplate
      .replace('{{business_logo}}', companyData.logo || './assets/images/logo.png')
      .replace('{{business_header}}', companyData.name || 'Your Company')
      .replace('{{business_address}}', companyData.address || 'Your Address')
      .replace('{{business_phone}}', companyData.phone || 'Your Phone')
      .replace('{{business_email}}', companyData.email || 'Your Email')
      .replace('{{vat_reg_no}}', companyData.vatRegNo || 'Your VAT Reg No')
      .replace('{{invoice_number}}', invoiceNumber || 'N/A')
      .replace('{{order_number}}', invoiceData.orderNumber ? `<div>Order No: ${invoiceData.orderNumber}</div>` : '')
      .replace('{{job_site_address}}', invoiceData.job_site_address ? `<div >Site Address: ${invoiceData.job_site_address}</div>` : '')
      .replace('{{issue_date}}', convertDateFormat(invoiceData.issuedDate) || 'N/A')
      .replace('{{issue_date_footer}}', convertDateFormat(invoiceData.issuedDate) || 'N/A')
      .replace('{{type}}', 'Invoice')
      .replace('{{customer_name}}', invoiceData.customerName || 'N/A')
      .replace('{{customer_address}}', invoiceData?.customerAddress )
      .replace('{{customer_phone}}', invoiceData.customerPhone || 'N/A')
      .replace('{{accountNumber}}', companyData.accountNumber || 'N/A')
      .replace('{{sortCode}}', companyData.sortCode || 'N/A')
      .replace('{{accountTitle}}', companyData.accountTitle || 'N/A')
      .replace('{{service_items}}', serviceItems)
      .replace('{{subtotal}}', calculateSubtotal().toFixed(2))
      .replace('{{discount}}', discount === 0 ? '<div style="padding:15px;"></div>' : `<div style="padding:5px">Discount: £${calculateDiscount().toFixed(2)}</div>`)
      .replace('{{tax}}', taxAmount !== 0 ? `<div style="padding:5px;">Total VAT Amount: £${calculateTax().toFixed(2)}</div>` : '<div style="padding:15px;"></div>')
      .replace('{{total}}', calculateTotal().toFixed(2))
      .replace('{{business_footer}}', companyData.name || 'Your Company')
      .replace('{{business_phones}}', companyData.phone || 'Your Phone');
  };

  const handleInvoiceSubmit = async () => {
    if (validateStep()) {
      setIsSubmitting(true);
      try {
        const obj = {
          invoice_number: invoiceNumber,
          customer_name: invoiceData.customerName,
          phone: invoiceData.customerPhone,
          address: invoiceData?.customerAddress,
          email: invoiceData.email,
          issue_date: invoiceData.issuedDate,
          order_number: invoiceData.orderNumber || null,
          due_date: invoiceData.dueDate,
          amount: calculateTotal(),
          discount: discount,
          tax: taxAmount,
          job_site_address:invoiceData.job_site_address,
          job_id: jobId,
          items: invoiceItems.map((item) => ({
            id: item.id,
            itemName: item.itemName,
            qty: item.qty,
            unitPrice: item.unitPrice,
            price: item.price,
            description: item.description,
          })),
          company_id: companyData.id || null,
          customer_id: null, // Customer ID not needed as linked via job_id
          type_of_invoice: 'invoice',
        };

        const response = await fetch(`${API_URL}/api/invoice/create`, {
          method: 'POST',
          body: JSON.stringify(obj),
          headers: {
            'Content-Type': 'application/json',
          },
        });

        const data = await response.json();
        if (response.status === 201) {
          setAlert({ show: true, type: 'primary', message: 'Invoice added successfully!' });
          Swal.fire({
            title: 'Invoice',
            text: 'Your invoice is successfully created.',
            icon: 'success',
          });
          // Reset form
          setInvoiceItems([]);
          setDiscount(0);
          setTaxAmount(0);
          setCurrentStep(1);
          setErrors({});
        } else {
          setAlert({
            show: true, type: 'danger', message: data.message || 'Failed to add invoice',
          });
        }
      } catch (error) {
        setAlert({
          show: true, type: 'danger', message: error.message || 'Network error occurred',
        });
      } finally {
        setIsSubmitting(false);
      }
    }
  };

  const closeAlert = () => {
    setAlert({ show: false, type: '', message: '' });
  };

  const steps = ['Customer and Invoice Details', 'Add Items', 'Preview'];

  return (
    <div className="container py-5">
      <style>
        {`
          .ql-container {
            font-family: Arial, sans-serif;
            font-size: 14px;
            min-height: 150px;
            border: 1px solid #ced4da;
            border-radius: 4px;
            direction: ltr;
          }
          .ql-container.is-invalid {
            border-color: #dc3545;
          }
          .ql-editor {
            min-height: 120px;
            padding: 10px;
          }
          .ql-toolbar {
            border-bottom: 1px solid #ced4da;
            border-top-left-radius: 4px;
            border-top-right-radius: 4px;
          }
          .ql-editor:focus {
            outline: none;
            box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
          }
          td ol, td ul {
            margin-bottom:0px;
            list-style: auto;
            padding-left:20px;
          }
          td p {
            margin-bottom:0px;
          }
          .react-select.is-invalid .select__control {
            border-color: #dc3545;
          }
        `}
      </style>
      <div className="row justify-content-center">
        <div className="col-lg-10">
          <div className="card shadow-sm border-0">
            <div className="card-header bg-white border-bottom">
              <h6 className="h6 mb-0 text-center">Create Invoice for Job #{jobId}</h6>
            </div>
            <div className="card-body">
              <div className="d-flex justify-content-center mb-5">
                {steps.map((step, index) => (
                  <div key={index} className="text-center mx-2">
                    <button
                      className={`btn btn-sm btn-${
                        currentStep > index + 1 ? 'success' : currentStep === index + 1 ? 'primary' : 'secondary'
                      } rounded-circle`}
                      style={{ width: '40px', height: '40px', lineHeight: '1' }}
                      onClick={() => handleStepClick(index + 1)}
                      disabled={currentStep < index + 1}
                    >
                      {index + 1}
                    </button>
                    <div className="mt-2 small">{step}</div>
                  </div>
                ))}
              </div>

              {alert.show && (
                <div className={`alert alert-${alert.type} alert-dismissible fade show mb-4`} role="alert">
                  {alert.message}
                  <button type="button" className="btn-close" onClick={closeAlert} aria-label="Close"></button>
                </div>
              )}

              {currentStep === 1 && (
                <div className="p-3 rounded">
                  <h2 className="h6 mb-4 mt-4">Company Information</h2>
                  <div className='mb-3'></div>
                  <Select
                  options={companies}
                  onChange={handleCompanyChange}
                  value={selectedCompany}
                  />
                  <div className='mb-3'></div>
                  <h2 className="h6 mb-4 mt-3">Customer Information</h2>
                  <div className="row g-3 mb-4">
                    <div className="col-md-6">
                      <label htmlFor="customerName" className="form-label fw-bold">Customer Name</label>
                      <input
                        type="text"
                        id="customerName"
                        value={invoiceData.customerName}
                        className="form-control form-control-lg"
                        readOnly
                      />
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="customerAddress" className="form-label fw-bold">Customer Address</label>
                      <input
                        type="text"
                        id="customerAddress"
                        value={invoiceData.customerAddress}
                        className="form-control form-control-lg"
                        readOnly
                      />
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="customerPhone" className="form-label fw-bold">Customer Phone</label>
                      <input
                        type="text"
                        id="customerPhone"
                        value={invoiceData.customerPhone}
                        className="form-control form-control-lg"
                        readOnly
                      />
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="email" className="form-label fw-bold">Customer Email</label>
                      <input
                        type="email"
                        id="email"
                        value={invoiceData.email}
                        className="form-control form-control-lg"
                        readOnly
                      />
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="postcode" className="form-label fw-bold">Postcode</label>
                      <input
                        type="text"
                        id="postcode"
                        value={invoiceData.postcode}
                        className="form-control form-control-lg"
                        readOnly
                      />
                    </div>
                  </div>
                  <h2 className="h6 mb-4 mt-3">Job Information</h2>
                  <div className='mb-3'></div>
                  <div className="row g-3 mb-4">
                    <div className="col-md-6">
                      <label htmlFor="JobLocation" className="form-label fw-bold">Job Location</label>
                      <input
                        type="text"
                        id="JobLocation"
                        value={mainData?.address}
                        className="form-control form-control-lg"
                        readOnly
                      />
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="customerAddress" className="form-label fw-bold">Postcode</label>
                      <input
                        type="text"
                        id="customerAddress"
                        value={mainData?.postcode}
                        className="form-control form-control-lg"
                        readOnly
                      />
                    </div>
                   
                  </div>
                  
                  <div className='mb-3'></div>
                  <h2 className="h6 mb-4">Invoice Details</h2>
                  <div className='mb-3'></div>
                  <div className="row g-3 mb-4">
                    
                    <div className="col-md-4">
                      <label htmlFor="invoiceNumber" className="form-label fw-bold">Invoice Number</label>
                      <input
                        type="text"
                        id="invoiceNumber"
                        value={invoiceNumber}
                        disabled
                        onChange={(e) => setInvoiceNumber(e.target.value)}
                        className={`form-control form-control-lg ${errors.invoiceNumber ? 'is-invalid' : ''}`}
                      />
                      <div className="form-text">e.g., INV-001</div>
                      {errors.invoiceNumber && <div className="invalid-feedback">{errors.invoiceNumber}</div>}
                    </div>
                    <div className="col-md-4">
                      <label htmlFor="issuedDate" className="form-label fw-bold">Issued Date</label>
                      <input
                        type="date"
                        id="issuedDate"
                        value={invoiceData.issuedDate}
                        onChange={(e) => handleInvoiceChange('issuedDate', e.target.value)}
                        className={`form-control form-control-lg ${errors.issuedDate ? 'is-invalid' : ''}`}
                      />
                      <div className="form-text">Select the issue date.</div>
                      {errors.issuedDate && <div className="invalid-feedback">{errors.issuedDate}</div>}
                    </div>
                    <div className="col-md-4">
                      <label htmlFor="dueDate" className="form-label fw-bold">Due Date</label>
                      <input
                        type="date"
                        id="dueDate"
                        value={invoiceData.dueDate}
                        onChange={(e) => handleInvoiceChange('dueDate', e.target.value)}
                        className={`form-control form-control-lg ${errors.dueDate ? 'is-invalid' : ''}`}
                      />
                      <div className="form-text">Select the due date.</div>
                      {errors.dueDate && <div className="invalid-feedback">{errors.dueDate}</div>}
                    </div>
                    <div className="col-md-4">
                      <label htmlFor="orderNumber" className="form-label fw-bold">Order Number</label>
                      <input
                        type="text"
                        id="orderNumber"
                        value={invoiceData.orderNumber}
                        onChange={(e) => handleInvoiceChange('orderNumber', e.target.value)}
                        className={`form-control form-control-lg ${errors.orderNumber ? 'is-invalid' : ''}`}
                      />
                      <div className="form-text">e.g., 12233</div>
                      {errors.orderNumber && <div className="invalid-feedback">{errors.orderNumber}</div>}
                    </div>
                    <div className="col-md-12">
                      <label htmlFor="job_site_address" className="form-label fw-bold">Site Address</label>
                      <input
                        type="text"
                        id="job_site_address"
                        value={invoiceData.job_site_address}
                        onChange={(e) => handleInvoiceChange('job_site_address', e.target.value)}
                        className={`form-control form-control-lg`}
                      />
                      
                    </div>
                  </div>
                </div>
              )}

              {currentStep === 2 && (
                <div className="p-3 rounded">
                  <h2 className="h6 mb-4">Add Items</h2>
                  <div className="card mb-4 shadow-sm">
                    <div className="card-body">
                      <div className="row g-3 align-items-end">
                        <div className="col-md-6">
                          <label htmlFor="itemType" className="form-label fw-bold">Item Type</label>
                          <select
                            id="itemType"
                            value={newItem.itemType}
                            onChange={(e) => {
                              setNewItem({ itemType: e.target.value, itemName: null, qty: '', unitPrice: '', description: '' });
                              if (quillInstance.current) {
                                quillInstance.current.root.innerHTML = '';
                                quillInstance.current.focus();
                              }
                              setErrors({});
                            }}
                            className="form-control form-control-lg"
                          >
                            <option value="stock">Stock</option>
                            <option value="service">Service</option>
                          </select>
                          <div className="form-text">Select item type.</div>
                        </div>
                        <div className="col-md-6">
                          <label htmlFor="itemName" className="form-label fw-bold">
                            {newItem.itemType === 'stock' ? 'Stock Item' : 'Service'}
                          </label>
                          <Select
                            inputId="itemName"
                            options={newItem.itemType === 'stock' ? stockList : optionsForServices}
                            value={newItem.itemName}
                            onChange={(e) => {
                              if (newItem.itemType === 'stock') {
                                onChangeStock(e);
                              } else {
                                onChangeService(e);
                              }
                            }}
                            className={`react-select ${errors.itemName ? 'is-invalid' : ''}`}
                            classNamePrefix="select"
                            placeholder={`Select ${newItem.itemType === 'stock' ? 'stock item' : 'service'}`}
                          />
                          <div className="form-text">
                            Select {newItem.itemType === 'stock' ? 'an item from stock' : 'a service'}.
                          </div>
                          {errors.itemName && <div className="invalid-feedback d-block">{errors.itemName}</div>}
                        </div>
                        <div className="col-md-6">
                          <label htmlFor="unitPrice" className="form-label fw-bold">Unit Price</label>
                          <input
                            type="number"
                            id="unitPrice"
                            value={newItem.unitPrice}
                            onChange={(e) => handleItemChange('unitPrice', e.target.value)}
                            className={`form-control form-control-lg ${errors.unitPrice ? 'is-invalid' : ''}`}
                            placeholder="Unit Price"
                            readOnly={newItem.itemType === 'stock' && newItem.itemName}
                          />
                          <div className="form-text">Enter the unit price.</div>
                          {errors.unitPrice && <div className="invalid-feedback">{errors.unitPrice}</div>}
                        </div>
                        {newItem.itemType === 'stock' && (
                          <div className="col-md-6">
                            <label htmlFor="qty" className="form-label fw-bold">Quantity</label>
                            <input
                              type="number"
                              id="qty"
                              value={newItem.qty}
                              onChange={(e) => handleItemChange('qty', e.target.value)}
                              className={`form-control form-control-lg ${errors.qty ? 'is-invalid' : ''}`}
                              placeholder="Quantity"
                            />
                            <div className="form-text">Enter the quantity.</div>
                            {errors.qty && <div className="invalid-feedback">{errors.qty}</div>}
                          </div>
                        )}
                        <div className="col-md-12">
                          <label htmlFor="description" className="form-label fw-bold">Description</label>
                          <div
                            ref={quillRef}
                            className={`ql-container ${errors.description ? 'is-invalid' : ''}`}
                          />
                          <div className="form-text">Provide a detailed description of the item or service (supports bold, bullet points, etc.).</div>
                          {errors.description && <div style={{ color: '#dc3545', fontSize: '0.875em' }}>{errors.description}</div>}
                        </div>
                        <div className={newItem.itemType === 'stock' ? 'col-md-4' : 'col-md-4'}>
                          <label className="form-label fw-bold d-block"> </label>
                          <button onClick={addItem} className="btn btn-success btn-lg w-200">
                            <Icon icon="simple-line-icons:plus" className="me-2" />
                            Add Item
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  {errors.items && <div className="alert alert-danger mb-4">{errors.items}</div>}
                  {invoiceItems.length > 0 && (
                    <div className="table-responsive mb-4">
                      <table className="table table-bordered table-hover">
                        <thead className="table-light">
                          <tr>
                            <th scope="col">SL.</th>
                            <th scope="col">Item</th>
                            <th scope="col">Quantity</th>
                            <th scope="col">Unit Price</th>
                            <th scope="col">Price</th>
                            <th scope="col" className="text-center">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {invoiceItems.map((item, index) => (
                            <tr key={item.id}>
                              <td>{index + 1}</td>
                              <td>
                                <p>{item.itemName?.label || item.itemName?.value}</p>
                                <div dangerouslySetInnerHTML={{ __html: item.description || 'N/A' }} />
                              </td>
                              <td>{item.qty}</td>
                              <td>£{item.unitPrice.toFixed(2)}</td>
                              <td>£{item.price}</td>
                              <td className="text-center">
                                <button onClick={() => removeItem(item.id)} className="btn btn-danger btn-sm">
                                  <Icon icon="ic:twotone-close" />
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                  <div className="row g-3">
                    <div className="col-md-6">
                      <label htmlFor="discount" className="form-label fw-bold">Discount (%)</label>
                      <input
                        type="number"
                        id="discount"
                        value={discount}
                        onChange={(e) => setDiscount(Number(e.target.value))}
                        className="form-control form-control-lg"
                        placeholder="Enter discount"
                      />
                      <div className="form-text">Enter discount percentage.</div>
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="tax" className="form-label fw-bold">VAT (%)</label>
                      <input
                        type="number"
                        id="tax"
                        value={taxAmount}
                        onChange={(e) => setTaxAmount(Number(e.target.value))}
                        className="form-control form-control-lg"
                        placeholder="Enter tax"
                      />
                      <div className="form-text">Enter VAT percentage.</div>
                    </div>
                    <div className="col-12 text-end">
                      <p className="mb-1"><strong>Total Net Amount:</strong> £{calculateSubtotal().toFixed(2)}</p>
                      <p className="mb-1"><strong>Discount:</strong> £{calculateDiscount().toFixed(2)}</p>
                      <p className="mb-1"><strong>VAT Amount:</strong> £{calculateTax().toFixed(2)}</p>
                      <p className="mb-0"><strong>Invoice Total:</strong> £{calculateTotal().toFixed(2)}</p>
                    </div>
                  </div>
                </div>
              )}

              {currentStep === 3 && (
                <div className="p-3 rounded">
                  <h2 className="h6 mb-4">Invoice Preview</h2>
                  <div className="border rounded p-4 bg-white" style={{ maxHeight: '600px', overflowY: 'auto' }}>
                    <div dangerouslySetInnerHTML={{ __html: renderTemplate() }} />
                  </div>
                </div>
              )}

              <div className="d-flex justify-content-between mt-5">
                {currentStep > 1 && (
                  <button onClick={handleBack} className="btn btn-secondary btn-lg">
                    Back
                  </button>
                )}
                <div>
                  {currentStep < 3 && (
                    <button onClick={handleNext} className="btn btn-primary btn-lg">
                      Next
                    </button>
                  )}
                  {currentStep === 3 && (
                    <button
                      onClick={handleInvoiceSubmit}
                      className="btn btn-success btn-lg"
                      disabled={isSubmitting}
                    >
                      <Icon icon="simple-line-icons:check" className="me-2" />
                      {isSubmitting ? 'Submitting...' : 'Submit Invoice'}
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default JobInvoiceLayer;